import styled, { AnyStyledComponent, createGlobalStyle, css } from 'styled-components';
import COLORS from '../../style/universal.color';
import * as datepickerStyle from 'react-datepicker/dist/react-datepicker.css';
import FONTS from '../../style/fonts';

const {
  mlbWhite,
  mlbBlack,
  linkBlue,
  linkBlueOnDark,
  mlbGrey1,
  mlbGrey2,
  mlbGrey3,
  mlbGrey4,
  mlbGrey6,
  mlbGrey7,
  focusedBlue
} = COLORS;

// modal is portalled to the body so we need to wrap up these styles here and add to
// the body below. Various tweaks to thirs party carousel / datepicker included here for mobile
const mobileModalStyle = css`
  .mobileDatePickerModal {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: none;

    > div > div:first-child {
      height: 100%;
    }

    .react-multi-carousel-list {
      margin: 0;
      width: 100%;
      height: 100%;

      .react-multi-carousel-track {
        height: 100%;

        li {
          display: flex;
          justify-content: center;

          > div {
            width: 90%;
          }
        }
      }
      .react-datepicker {
        border: none;
      }
      .react-datepicker__week,
      .react-datepicker__day-names {
        display: flex;
        justify-content: space-between;
        margin: 5px 0;
        border: none;

        .react-datepicker__day-name {
          font-size: 13px;
          font-weight: 900;
        }
      }
      .react-datepicker__header {
        margin: 20px .4rem 0;
      }
      .react-datepicker__navigation {
        top: 42px;
        box-sizing: border-box;
      }
      .react-datepicker__current-month {
        margin-bottom: 20px;
      }
      .react-datepicker__day {
        font-size: 13px;
      }
      @media only screen and (max-width: 360px) {
        .react-datepicker__week,
        .react-datepicker__day-names {
          margin: 8px 0;
        }
        .react-datepicker__header {
          margin: 15px .4rem 0;
        }
        .react-datepicker__navigation {
          top: 28px;
        }
      }
    }
    &.month-locked {
      .react-multi-carousel-list {
        .react-datepicker__navigation--previous {
          border-right-color: ${ mlbGrey1 };
          border-bottom-color: ${ mlbGrey1 };
        }
        .react-datepicker__navigation--next {
          border-top-color: ${ mlbGrey1 };
          border-left-color: ${ mlbGrey1 }; 
        }
    }
  }
  .react-datepicker__input-container > label {
    position: relative;
    top: 2px;
  }
`;

// use createGlobalStyle to include css styling from third party lib
// https://styled-components.com/docs/api#createglobalstyle
export const DatePickerStyle = createGlobalStyle`
  body {
    ${datepickerStyle}
    ${mobileModalStyle}
  }
`;

export interface DPWrapperProps {
  daysLabels: string[];
  dark: boolean;
  openLeft: boolean;
  isMobile?: boolean;
  openLeftMinBreakpoint: string | number;
  openLeftMaxBreakpoint?: string | number;
  dataAttr?: object;
}

// Sooo we cannot override the day labels https://github.com/Hacker0x01/react-datepicker/issues/1257
// We could put in a PR to the lib, but I just hacked together a solution here
// I tried to generate a string so this isn't so verbose, but styled-components wasn't accepting it :shrug:
export const DatePickerWrapper: AnyStyledComponent = styled.div`
  -webkit-touch-callout: none;
    -webkit-user-select: none;
      -khtml-user-select: none;
        -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;
        
  .react-datepicker-popper {
    z-index: 2;
    ${ ({openLeft, openLeftMinBreakpoint, openLeftMaxBreakpoint}: DPWrapperProps) => 
    openLeft ? `@media only screen and (min-width: ${openLeftMinBreakpoint})
    ${openLeftMaxBreakpoint ? `and (max-width: ${openLeftMaxBreakpoint})` : ''} {
      left: -285px !important;
    }` : '' }
  }
  .react-datepicker {
    background: ${({dark}: DPWrapperProps) => dark ? mlbGrey7 : mlbWhite};
    display: inline-flex;
    flex-direction: column;
    width: ${({isMobile}: DPWrapperProps) => isMobile ? '100%' : '308px'};
    height: ${({isMobile}: DPWrapperProps) => isMobile ? '100%' : 'auto'};
    font-family: ${FONTS.primaryFont};
  }
  .react-datepicker__navigation {
    box-sizing: border-box;
    padding: 3px;
    border-width: 2px;
    transform: rotateY(0deg) rotate(135deg);
    margin-top: 2px;
    &:focus {
      outline: 1px solid ${ focusedBlue };
    }
  }
  .react-datepicker__navigation--left {
    position: absolute;
    left: 61px;
    top: 5px;
  }
  .react-datepicker__navigation--right {
    position: absolute;
    right: 61px;
    top: 5px;
  }
  .react-datepicker__navigation--previous {
    border-bottom-color: #CCC;
    left: 61px;
    &:hover {
      border-bottom-color: ${ mlbGrey3 };
      border-right-color: ${ mlbGrey3 };
    }
  }
  .react-datepicker__navigation--next {
    border-top-color: #CCC;
    right: 61px;
    &:hover {
      border-left-color: ${ mlbGrey3 };
      border-top-color: ${ mlbGrey3 };
    }
  }
  .react-datepicker__triangle {
    display: none;
  }
  .react-datepicker__header {
    background: ${({dark}: DPWrapperProps) => dark ? mlbGrey7 : mlbWhite};
    border-bottom: none;
  }
  .react-datepicker__week {
    display: flex;
  }
  .react-datepicker__month {
    height: 200px;
  }
  .react-datepicker__day {
    font-weight: 600;
    flex: 1 1 0px;
    color: ${({dark}: DPWrapperProps) => dark ?  mlbWhite : mlbGrey6};
    ${({dark}: DPWrapperProps) => dark ?  `
      &:hover {
        background-color: ${mlbGrey6};
      }
    ` : ''};
  }
  .react-datepicker__day--disabled {
    color: ${mlbGrey3};
  }
  .react-datepicker__day--today {
    color: ${({dark}: DPWrapperProps) => dark ? linkBlueOnDark : linkBlue};
  }
  .react-datepicker__day--keyboard-selected {
    background: ${({dark}: DPWrapperProps) => dark ? mlbGrey7 : mlbWhite};
    &:hover {
      background: ${({dark}: DPWrapperProps) => dark ? mlbGrey6 : mlbGrey1};
    }
  }
  .react-datepicker__input-container {
    display: flex;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--highlighted,
  .react-datepicker__day--highlighted:hover {
    background-color: ${({dark}: DPWrapperProps) => dark ? linkBlueOnDark : linkBlue};
    color: ${mlbWhite};
  }
  .react-datepicker__current-month {
    color: ${({dark}: DPWrapperProps) => dark ?  mlbWhite : mlbGrey7};
    font-weight: bold;
    font-size: 15px;
    padding-top: 5px;
  }
  .react-datepicker__day--outside-month {
    color: ${mlbGrey3};
    font-weight: 400;
  }
  .react-datepicker__day-name {
    color: ${mlbGrey4};
  }
  .react-datepicker__day-names {
    margin-top: 10px;
    display: flex;
    margin: 0 .4rem;
    font-size: 11px;
    font-weight: 900;
    margin-top: 25px;

    > div {
      visibility: hidden;
      flex: 1 1 0px;
      line-height: 11px;
    }
    > div:after {
      position: relative;
      right: 8px;
      visibility: visible;
    }
    > div:nth-child(1):after {
      content: '${({daysLabels}: DPWrapperProps) => daysLabels[0]}';
    }
    > div:nth-child(2):after {
      content: '${({daysLabels}: DPWrapperProps) => daysLabels[1]}';
    }
    > div:nth-child(3):after {
      content: '${({daysLabels}: DPWrapperProps) => daysLabels[2]}';
    }
    > div:nth-child(4):after {
      content: '${({daysLabels}: DPWrapperProps) => daysLabels[3]}';
    }
    > div:nth-child(5):after {
      content: '${({daysLabels}: DPWrapperProps) => daysLabels[4]}';
    }
    > div:nth-child(6):after {
      content: '${({daysLabels}: DPWrapperProps) => daysLabels[5]}';
    }
    > div:nth-child(7):after {
      content: '${({daysLabels}: DPWrapperProps) => daysLabels[6]}';
    }
  }
`;

export interface MiniYearWrapperProps {
  mobileBreakpoint: string;
}

export const MiniYearWrapper: AnyStyledComponent = styled.div`
  padding: 0px 3px;
  width: calc(100% - 6px);
  display: block;
  text-align: center;
  >div {
    width: 50px;
    >button {
      width: 35px;
      box-sizing: content-box;
    }
  }
  @media only screen and (max-width: ${({mobileBreakpoint}: MiniYearWrapperProps) => mobileBreakpoint}) {
    position: absolute;
    bottom: 100px;
  }
`;

export interface MiniYearButtonWrapperProps {
  isCurrentYear: boolean;
  isActiveYear: boolean;
  fitWidth: boolean;
  dark: boolean;
}

export const MiniYearButtonWrapper: AnyStyledComponent = styled.div`
  ${({fitWidth}: MiniYearButtonWrapperProps) => fitWidth ? '' : 'width: 40px;'}
  display: inline-block;
  button {
    padding-left: 6px;
    padding-right: 6px;
    width: 100%;
    svg {
      overflow: visible;
      transform: rotate(90deg);
    }

    ${({dark, isActiveYear}: MiniYearButtonWrapperProps) => !isActiveYear ? `
      &:hover{
        color: ${dark ? mlbWhite : mlbBlack};
        background-color: ${dark ? mlbGrey6 : mlbGrey1};
      }
    ` : ''}
  
    color: ${({dark}: MiniYearButtonWrapperProps) => dark ? mlbWhite : mlbBlack};
    ${({isCurrentYear, dark}: MiniYearButtonWrapperProps) => isCurrentYear ? `
      color: ${dark ? linkBlueOnDark : linkBlue};
    ` : ''}
    ${({isActiveYear, dark}: MiniYearButtonWrapperProps) => isActiveYear ? `
      background-color: ${dark ? linkBlueOnDark : linkBlue};
      color: ${mlbWhite};
    ` : ''}
  }
`;

export interface YearSelectWrapperProps {
  showYearSelect: boolean;
  dark: boolean;
}

export const YearSelectWrapper: AnyStyledComponent = styled.div`
  height: calc(100% - 10px);
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: ${({dark}: YearSelectWrapperProps) => dark ? mlbGrey7 : mlbWhite };
  z-index: 10;
  flex-wrap: wrap;
  overflow: auto;
  display: ${({showYearSelect}: YearSelectWrapperProps) => showYearSelect ? 'flex' : 'none'};
  border-radius: inherit;
  padding: 5px 0px;
`;

export interface YearRowWrapperProps {
  index: number;
  endDecade: boolean;
  midDecade: boolean;
}

const yearRowHorizontalPadding: number = 6;

export const YearRowWrapper: AnyStyledComponent = styled.div`
  height: 32px;
  padding: 2px ${yearRowHorizontalPadding}px;
  display: flex;
  ${({midDecade}: YearRowWrapperProps) => midDecade ? 'justify-content: flex-end' : ''};
  flex: 0 0 calc(100% - ${yearRowHorizontalPadding * 2}px);
  position: relative;
  >div {
    width: 20%;
    height: 32px;
    button {
      padding: 0px;
      width: 100%;
    }
  }
  
  ${({index, endDecade}: YearRowWrapperProps) => (index !== 0 && endDecade)
    ? `
      margin-bottom: 10px;
      &:after {
        margin: 5px 0px;
        position: absolute;
        bottom: -10px;
        width: 28px;
        background-color: ${mlbGrey2};
        height: 1px;
        left: 22px;
        content: '';
      }
    ` : '' }
`;

export const ButtonWrapper: AnyStyledComponent = styled.div`
  display: flex;
  justify-content: center;
  margin: 25px 0 10px;

  button:hover {
    svg {
      fill: white !important;
    }
  }
`;

export const MobileButtonWrapper: AnyStyledComponent = styled(ButtonWrapper)`
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 36px;
  button {
    width: 140px;
  }
`;

export const InputLabel: AnyStyledComponent = styled.label<{ disabled: boolean; }>`
  svg {
    cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
  }
  position: absolute;
`;

export const InputWrapper: AnyStyledComponent = styled.input<{ fill: string; }>`
  opacity: 1;
  width: 22px;
  height: 25px;
  cursor: default;
  color: transparent;
  background: transparent;
  text-indent: -9999px;
  font-size:0;
  border: 0;
  &:focus {
    outline: 2px auto ${({ fill }) => fill ? fill : ''};
  }
`;

const skeletonWeek: string = `
  margin-top: 19px;
  height: 22px;
  div {
    margin: 0;
  }
`

export const SkeletonWrapper: AnyStyledComponent = styled.div`
  width: 100%;
  justify-content: center;
  > div {
    padding: 0 14px;
  }
  .skeleton-date-label {
    margin: 0 auto;
    width: 120px;
    margin-top: 26px;
    height: 23px;
    margin-bottom: 17px;
    
  }
  .skeleton-week-labels {
    height: 16px;
    margin-bottom: 14px;
  }
  .skeleton-week-full {
    ${skeletonWeek}
  }
  .skeleton-week-part-first {
    ${skeletonWeek}
    padding-left: 75px;
  }
  .skeleton-week-part-last {
    ${skeletonWeek}
    padding-right: 75px;
  }
  .skeleton-today-button {
    width: 140px;
    top: 400px;
    position: absolute;
    height: 36px;
    left: calc(50% - 84px);
  }
`;
